export const STEPS = [
  { id: "consultant", label: "Consultant Information" },
  { id: "business", label: "Business & Tax Information" },
  { id: "payment", label: "Payment Information" },
  { id: "documents", label: "Compliance Documents" },
  { id: "review", label: "Review & Acknowledgment" },
];

export const INITIAL_VALUES = {
  firstName: "", lastName: "", preferredName: "", personalEmail: "", phoneNumber: "", businessName: "",
  businessAddress: "", city: "", state: "", zip: "", country: "US", businessType: "",
  otherBusinessType: "", taxId: "", stateOfFormation: "",
  paymentMethod: "", bankName: "", accountName: "", accountNumber: "", routingNumber: "",
  swiftCode: "", remittanceEmail: "", paymentTerms: "", otherPaymentTerms: "",
};
export type ConsultantUsValues = typeof INITIAL_VALUES;
export type FieldKey = keyof ConsultantUsValues;
export interface FieldDefinition {
  key: FieldKey;
  label: string;
  placeholder: string;
  type?: "email" | "tel" | "text";
  hint?: string;
}

export const CONSULTANT_FIELDS: FieldDefinition[] = [
  { key: "firstName", label: "First Name", placeholder: "Enter First Name" },
  { key: "lastName", label: "Last Name", placeholder: "Enter Last Name" },
  { key: "preferredName", label: "Preferred Name", placeholder: "Enter Preferred Name"},
  { key: "personalEmail", label: "Personal Email Address", placeholder: "Enter Personal Email Address", type: "email" },
  { key: "phoneNumber", label: "Phone Number", placeholder: "Enter Phone Number", type: "tel" },
  { key: "businessName", label: "Business / DBA Name", placeholder: "Enter Business / DBA Name", hint: "If applicable." },
];
export const BUSINESS_FIELDS: FieldDefinition[] = [
  { key: "businessAddress", label: "Business Address", placeholder: "Enter Business Address" },
  { key: "city", label: "City", placeholder: "Enter City" },
  { key: "state", label: "State", placeholder: "Enter State" },
  { key: "zip", label: "ZIP/Postal Code", placeholder: "Enter ZIP/Postal Code" },
  { key: "country", label: "Country", placeholder: "Enter Country" },
  { key: "taxId", label: "Tax ID (EIN or SSN)", placeholder: "Enter Tax ID (EIN or SSN)" },
  { key: "stateOfFormation", label: "State of Formation / Incorporation", placeholder: "Enter State of Formation / Incorporation", hint: "If applicable." },
];
export const PAYMENT_FIELDS: FieldDefinition[] = [
  { key: "bankName", label: "Bank Name", placeholder: "Enter Bank Name" },
  { key: "accountName", label: "Account Name", placeholder: "Enter Account Name" },
{ key: "accountNumber", label: "Account Number", placeholder: "Enter Account Number", type: "tel" },  { key: "routingNumber", label: "Routing Number", placeholder: "Enter Routing Number" },
  { key: "swiftCode", label: "SWIFT Code", placeholder: "Enter SWIFT Code", hint: "For international payments, if applicable." },
  { key: "remittanceEmail", label: "Remittance Email", placeholder: "Enter Remittance Email", type: "email" },
];
export const BUSINESS_TYPES = [
  { value: "individual", label: "Individual / Sole Proprietor" },
  { value: "llc", label: "LLC" },
  { value: "corporation", label: "Corporation" },
  { value: "partnership", label: "Partnership" },
  { value: "other", label: "Other" },
];
export const PAYMENT_METHODS = [
  { value: "ach", label: "ACH / Direct Deposit" },
  { value: "wire", label: "Wire Transfer" },
  { value: "check", label: "Check" },
];
export const PAYMENT_TERMS = [
  { value: "net15", label: "Net 15" },
  { value: "net30", label: "Net 30" },
  { value: "net45", label: "Net 45" },
  { value: "other", label: "Other" },
];
export const DOCUMENTS = [
  { id: "tax", label: "Completed and signed W-9", hint: "Or applicable W-8 for an international consultant." },
  { id: "agreement", label: "Executed Independent Contractor / Consultant Agreement", hint: "Attach your executed agreement, as applicable." },
  { id: "nda", label: "Executed NDA / Confidentiality Agreement", hint: "If required." },
  { id: "insurance", label: "Certificate of Insurance", hint: "If required." },
  { id: "businessLicenseCredential", label: "Business License or Professional Credential", hint: "If applicable." },
  { id: "certification", label: "Professional Certification or License", hint: "If required for the engagement." },
  { id: "client", label: "Client-specific Onboarding or Compliance Documentation", hint: "As requested by Caelius." },
] as const;
export type DocumentId = typeof DOCUMENTS[number]["id"];

// Replace this URL with the W-9 asset when available.
export const W9_DOWNLOAD_URL = "/assets/W9_Form.pdf";
export const ACKNOWLEDGMENT = "I certify that the information provided above is accurate and complete. I understand that onboarding is subject to completion of all required agreements, tax documentation, compliance requirements, and project-specific approvals. I agree to provide timely notice of any changes to the information provided.";

export const OTHER_BUSINESS_FIELD: FieldDefinition = { key: "otherBusinessType", label: "Other Business Type", placeholder: "Enter Other Business Type" };
export const OTHER_PAYMENT_TERMS_FIELD: FieldDefinition = { key: "otherPaymentTerms", label: "Other Payment Terms", placeholder: "Enter Other Payment Terms" };
